enum SiteListType {
  Comprehensive = 'Comprehensive site list',
  New = 'New sites only',
  Sold = 'Sold sites only',
}

export default SiteListType;
